import React from 'react';

import GridWrap from './styled/Wrap';
import { FlexGridProps } from './types';

const FlexGrid: React.FC<FlexGridProps> = props => (
  <GridWrap itemsPerRow={props.itemsPerRow}>{props.children}</GridWrap>
);

export default FlexGrid;
